// removed by extract-text-webpack-plugin
module.exports = {"BeerDetails":"BeerDetails__BeerDetails__-hash-base-64-5-","Pictures":"BeerDetails__Pictures__-hash-base-64-5-","MainImage":"BeerDetails__MainImage__-hash-base-64-5-","TextDescr":"BeerDetails__TextDescr__-hash-base-64-5-","TextDescrHidden":"BeerDetails__TextDescrHidden__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/containers/BeerDetails/BeerDetails.scss
// module id = 180
// module chunks = 0